import { atom } from "recoil";
import { IFontType } from "../types/EmailTypes";
import { ILabel } from "../types/LabelTypes";
import { ITagQuery } from "../types/TagQueryTypes";

export interface INewEmailAtom {
  subject: string;
  body: string;
  labels: Array<ILabel>;
  isFavorite: boolean;
  font: IFontType;
  scheduleTo?: Date;
  tagQuery?: ITagQuery;
}

export const NewEmailAtom = atom<INewEmailAtom>({
  key: "NewEmailAtom",
  default: {
    subject: "",
    body: "",
    labels: [],
    font: "Arial",
    isFavorite: false,
    tagQuery: undefined,
  },
});
